import {
  TimeZoneList,
  TIMEZONE_KEY,
  useTimeZone,
  useTranslation,
  timeZoneList
} from '@fareye/common'
import { Link, Modal, Span } from '@fareye/ui'
import {
  AiOutlineClockCircle,
  FaCheck,
  FaChevronRight,
  tzFormat
} from '@fareye/utils'
import React from 'react'
import { ProfileSubMenu } from '../../style/styled'
import enUS from 'date-fns/locale/en-US'

function TimeZone({ bg }: { bg: string }) {
  const { state, setState } = useTimeZone()
  const { t } = useTranslation()
  const TZ_DISPLAY = () =>
    tzFormat(new Date(), 'z', {
      timeZone: state.value || 'GMT',
      locale: enUS
    })

  const [timeZoneModal, setTimeZoneModal] = React.useState(false)
  function handleClick(ele: any) {
    let data = {
      id: ele.abbr,
      text: ele.text,
      value: ele.value,
      displayText: ele.text
    }
    setState(data)
    localStorage.setItem(TIMEZONE_KEY, JSON.stringify(data))
  }

  return (
    <>
      <Link to={'#'} onClick={(e: any) => e.preventDefault()}>
        <AiOutlineClockCircle size={20} />
        {t('Timezone')}
        <ProfileSubMenu style={{ minWidth: 150 }} column>
          {timeZoneList.map((ele: any, index: number) => {
            let selected = ele.id === state.id
            return (
              <Span
                key={`${ele.text}-${index}`}
                onClick={() => handleClick(ele)}
              >
                {ele.text}
                {selected ? (
                  <FaCheck
                    size={10}
                    style={{
                      margin: 'auto',
                      padding: '3px 0 0 10px',
                      height: 10
                    }}
                  />
                ) : null}
              </Span>
            )
          })}
          <Span onClick={() => setTimeZoneModal(true)}>
            {state.id === 'others' ? TZ_DISPLAY() : 'Others'}
            <FaChevronRight style={{ marginLeft: 10 }} />
            {state.id === 'others' ? (
              <FaCheck
                size={10}
                style={{
                  margin: 'auto',
                  padding: '3px 0 0 10px',
                  height: 10
                }}
              />
            ) : null}
          </Span>
        </ProfileSubMenu>
      </Link>
      {timeZoneModal && (
        <Modal
          variant="l"
          toggleModal={timeZoneModal}
          setToggleModal={setTimeZoneModal}
        >
          <TimeZoneList
            setToggleModal={setTimeZoneModal}
            state={state}
            setState={setState}
          />
        </Modal>
      )}
    </>
  )
}
export default TimeZone
